import { RefObject, useState } from 'react';

type UseInlineRenameProps = {
  initialName: string;
  inputRef: RefObject<HTMLInputElement | null>;
  onSave: (newName: string) => void;
  onStartRename?: () => void;
};

export const useInlineRename = ({
  initialName,
  inputRef,
  onSave,
  onStartRename,
}: UseInlineRenameProps) => {
  const [isRenaming, setIsRenaming] = useState(false);
  const [editedName, setEditedName] = useState(initialName);

  const handleStartRename = () => {
    setEditedName(initialName);
    setIsRenaming(true);
    onStartRename?.();
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        const { length } = inputRef.current.value;
        inputRef.current.setSelectionRange(length, length);
      }
    }, 0);
  };

  const handleSaveRename = () => {
    const trimmedName = editedName.trim();
    if (trimmedName && trimmedName !== initialName) {
      onSave(trimmedName);
    }
    setIsRenaming(false);
  };

  const handleCancelRename = () => {
    setEditedName(initialName);
    setIsRenaming(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSaveRename();
    } else if (event.key === 'Escape') {
      handleCancelRename();
    }
  };

  return {
    isRenaming,
    editedName,
    setEditedName,
    handleStartRename,
    handleSaveRename,
    handleCancelRename,
    handleKeyDown,
  };
};
